import * as React from "react";
import { useEffect, useState } from "react";
import { CalendarState, MonthDividerInfo } from "burde";
import { connect } from "react-redux";
import { MonthDividerResource } from "burde";
import { actionCreators } from "page/calendar/store";
import * as cn from "classnames/bind";
import * as styles from "./month-divider-selector.css";
import MonthDividerPicker from "./month-divider-picker/month-divider-picker";
import { useResources } from "contexts/resource-context";
import { MonthDividerNumberOfPages } from "svg/constants";
import ConfirmationModal from "common/confirmation-modal";
import Button from "content/button/button";

const cx = cn.bind(styles);

const tabGroupCn = () =>
    cx({
        tabGroup: true,
    });

const tabGroupLiCn = () =>
    cx({
        tabGroupLi: true,
    });

const tabItemCn = (isSelected: boolean) =>
    cx({
        categoryTabItem: true,
        categoryTabItemSelected: isSelected,
    });

const checkboxCn = (isInactive: boolean) =>
    cx({
        checkBoxWrap: true,
        isInactive: isInactive,
    });

const checkBoxSpanCn = (isChecked: boolean, isInactive: boolean) =>
    cx({
        checkBoxWrapSpan: true,
        checkBoxWrapSpanSelected: isChecked,
        fas: isChecked,
        "fa-check": isChecked,
        isInactive: isInactive,
    });

type MonthDividerSelectorProps = {
    calendar: CalendarState;
    monthDividerResources: MonthDividerResource[] | undefined;
    numberOfPagesLeft: number;
} & typeof actionCreators;

const MonthDividerSelector = ({
    calendar,
    monthDividerResources,
    updateMonthDivider,
    numberOfPagesLeft,
}: MonthDividerSelectorProps) => {
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [showModal, setShowModal] = useState<boolean>(false);
    const resources = useResources();

    const onUpdateMonthDivider = (monthDivider: MonthDividerInfo | null) => {
        if (
            numberOfPagesLeft < MonthDividerNumberOfPages &&
            calendar.monthDivider === null
        ) {
            setShowModal(true);
        } else {
            updateMonthDivider(monthDivider);
        }
    };

    return (
        <div>
            {monthDividerResources !== undefined ? (
                <div>
                    {monthDividerResources.length > 1 && (
                        <ul className={tabGroupCn()}>
                            {monthDividerResources.map((item, index) => (
                                <li
                                    key={item.resourceGroupTitle}
                                    className={tabGroupLiCn()}>
                                    <a
                                        className={tabItemCn(
                                            index === selectedTab,
                                        )}
                                        onClick={() => setSelectedTab(index)}>
                                        {item.resourceGroupTitle}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                    {monthDividerResources !== undefined &&
                        monthDividerResources[selectedTab] !== null && (
                            <MonthDividerPicker
                                onClick={onUpdateMonthDivider}
                                selected={calendar.monthDivider}
                                monthDividers={
                                    monthDividerResources[selectedTab].content
                                }
                            />
                        )}
                    {(calendar.borderImageId !== null ||
                        calendar.borderColor !== null) && (
                        <div className={styles.checkBoxDiv}>
                            <label
                                className={checkboxCn(
                                    calendar.monthDivider === null,
                                )}
                                onClick={() => {
                                    if (calendar.monthDivider !== null) {
                                        updateMonthDivider({
                                            ...calendar.monthDivider,
                                            showFrame: !calendar.monthDivider
                                                .showFrame,
                                        });
                                    }
                                }}>
                                {resources["MonthDivider_ShowFrame"]}
                                <span
                                    className={checkBoxSpanCn(
                                        calendar.monthDivider !== null &&
                                            calendar.monthDivider.showFrame ===
                                                true,
                                        calendar.monthDivider === null,
                                    )}
                                />
                            </label>
                        </div>
                    )}
                    <div className={styles.checkBoxDiv}>
                        <label
                            className={checkboxCn(false)}
                            onClick={() => {
                                if (calendar.monthDivider !== null) {
                                    updateMonthDivider(null);
                                }
                            }}>
                            {resources["MonthDivider_NoneSelected"].replace(
                                "{0}",
                                `${MonthDividerNumberOfPages}`,
                            )}
                            <span
                                className={checkBoxSpanCn(
                                    calendar.monthDivider === null,
                                    false,
                                )}
                            />
                        </label>
                    </div>
                </div>
            ) : (
                <div />
            )}
            <ConfirmationModal
                isOpen={showModal}
                title={resources["MonthDivider_NoRoomTitle"]}
                message={resources["MonthDivider_NoRoomDescription"].replace(
                    "{0}",
                    `${(numberOfPagesLeft - MonthDividerNumberOfPages) * -1}`,
                )}
                content={
                    <div>
                        <Button
                            onClick={() => setShowModal(false)}
                            text={resources["MonthDivider_NoRoomConfirm"]}
                        />
                    </div>
                }
            />
        </div>
    );
};

const mapDispatchToProps = {
    ...actionCreators,
};

export default connect(null, mapDispatchToProps)(MonthDividerSelector);
